import type { Form } from "../types";
import FormListItem from "./form-list-item";

export interface FormListProps {
	forms: Form[];
	onDelete?: (id: string) => void;
	onEdit?: (id: string) => void;
	onClone?: (id: string) => void;
	onStatusChange?: (id: string, status: string) => void;
}

export default function FormList({ forms, onDelete, onEdit, onClone, onStatusChange }: FormListProps) {
	return (
		<>
			<div className="space-y-2">
				{forms.map((form, index) => (
					<FormListItem key={`${form.id}-${index}`} form={form} onDelete={onDelete} onEdit={onEdit} onClone={onClone} onStatusChange={onStatusChange} />
				))}
			</div>
		</>
	);
}
